import { render, staticRenderFns } from "./consignee.vue?vue&type=template&id=70b3955d&"
import script from "./consignee.vue?vue&type=script&lang=js&"
export * from "./consignee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70b3955d')) {
      api.createRecord('70b3955d', component.options)
    } else {
      api.reload('70b3955d', component.options)
    }
    module.hot.accept("./consignee.vue?vue&type=template&id=70b3955d&", function () {
      api.rerender('70b3955d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uiCustom/ae/basic/consignee.vue"
export default component.exports